/**
 * Preços dos serviços, num só sítio para o preçário, os cartões e o modal.
 *
 * Um serviço do catálogo (`src/data/services.js`) pode ter o preço em três formas:
 *   "price": 15                                → preço único
 *   "price": 90, "price_from": true            → "a partir de 90,00 €"
 *   "prices_by_length": { curto, medio, ... }  → um preço por comprimento de cabelo
 * e qualquer preço pode ser o texto "Sob consulta".
 */

export const SOB_CONSULTA = 'Sob consulta'

export const HAIR_LENGTHS = [
  { key: 'curto', label: 'Curto' },
  { key: 'medio', label: 'Médio' },
  { key: 'longo', label: 'Longo' },
  { key: 'extra_longo', label: 'Extra longo' },
]

export const formatEuro = (n) => `${n.toFixed(2).replace('.', ',')} €`

/** Um valor isolado: número formatado, ou o texto tal como vem ("Sob consulta"). */
export const formatPriceValue = (p) =>
  typeof p === 'number' ? formatEuro(p) : p || SOB_CONSULTA

export const hasLengthPrices = (svc) =>
  !!svc?.prices_by_length && typeof svc.prices_by_length === 'object'

/** Lista [{ key, label, value, numeric }] pela ordem curto → extra longo. */
export const getLengthPrices = (svc) =>
  HAIR_LENGTHS.map(({ key, label }) => {
    const raw = svc.prices_by_length?.[key]
    return { key, label, value: formatPriceValue(raw), numeric: typeof raw === 'number' }
  })

/**
 * Preço resumido para um cartão ou uma linha: `prefix` ("a partir de") vem à
 * parte para poder ser mais discreto que o valor.
 */
export const getPriceSummary = (svc) => {
  if (hasLengthPrices(svc)) {
    const nums = Object.values(svc.prices_by_length).filter((v) => typeof v === 'number')
    return nums.length
      ? { prefix: 'a partir de', value: formatEuro(Math.min(...nums)), numeric: true }
      : { prefix: null, value: SOB_CONSULTA, numeric: false }
  }
  if (svc.price_from && typeof svc.price === 'number') {
    return { prefix: 'a partir de', value: formatEuro(svc.price), numeric: true }
  }
  return { prefix: null, value: formatPriceValue(svc.price), numeric: typeof svc.price === 'number' }
}

/**
 * Agrupa serviços pelo campo `group`, mantendo a ordem do catálogo. Serviços
 * sem grupo ficam num grupo sem nome (`nome: null`).
 */
export const groupServices = (lista) => {
  const grupos = []
  lista.forEach((svc) => {
    const nome = svc.group || null
    let grupo = grupos.find((g) => g.nome === nome)
    if (!grupo) {
      grupo = { nome, itens: [] }
      grupos.push(grupo)
    }
    grupo.itens.push(svc)
  })
  return grupos
}
